import PropTypes from 'prop-types';
import classNames from 'classnames';
import './divider.css';

function Divider(props) {
  return (
    <div className={classNames('divider', 'w-100 mx-0 my-6 border-b text-center', props.className)}>
      {props.content && <span className='bg-white px-0'>{props.content}</span>}
    </div>
  );
}

Divider.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string
};

export default Divider;
